import React from 'react';
import { useParams } from 'react-router-dom';
import { useDrafts } from '../contexts/DraftContext';

interface DraftRouteGuardProps {
  children: React.ReactNode;
}

const DraftRouteGuard: React.FC<DraftRouteGuardProps> = ({ children }) => {
  const { id } = useParams<{ id: string }>();
  const { savedDrafts, currentDraft, areDraftsLoading } = useDrafts();
  
  if (!id) {
    return <>{children}</>;
  }

  // If the current draft matches the route id, allow rendering immediately
  if (currentDraft?.id === id) {
    return <>{children}</>;
  }

  // Show loading state while drafts are being loaded
  if (areDraftsLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: 'var(--app-height, 100svh)',
        fontSize: '1.2rem',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }
  
  // If we have an ID, check saved drafts; if not found, show a gentle message
  const draftExists = savedDrafts.some(draft => draft.id === id);
  if (!draftExists) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: 'var(--app-height, 100svh)',
        fontSize: '1.2rem',
        color: '#666'
      }}>
        Couldn’t find that note. Pull to refresh.
      </div>
    );
  }
  
  return <>{children}</>;
};

export default DraftRouteGuard; 
